import { ApiSastreRecommendation, ApiSastreSizeInfo } from '../infrastructure/sastre-button.api.model';

import { SastreRecommendation } from './sastre-button.model';

// biome-ignore lint/complexity/noStaticOnlyClass: <explanation>
export class SastreButtonTransformer {
    public static IsActivated(sizeInfo: ApiSastreSizeInfo): boolean {
        return sizeInfo.recommender.name === 'Sastre';
    }

    public static Recommendation(data: ApiSastreRecommendation): SastreRecommendation {
        return { sizeResult: data?.recommendation?.sizeResult || null };
    }
}
